import { formatAmount } from "@utils";
import RollingNumber from "./RollingNumber";
import PeriodSelect from "./PeriodSelect";
import { useTaskMetrics, useMetricPeriod, METRIC_PERIODS } from "../hooks/useTaskMetrics";

// The collected figure in the page header, with its own period selector. Silent on error (renders an
// em dash) rather than showing a misleading £0.
const CollectedToday = () => {
  const [period, setPeriod] = useMetricPeriod("tasks.metricPeriod.header");
  const { data, isLoading } = useTaskMetrics(period);
  const activePeriod = METRIC_PERIODS.find((p) => p.key === period) ?? METRIC_PERIODS[0];

  return (
    <div className="flex items-center gap-2 text-[13px]">
      {/* Pulses to signal the figure is live (updates in realtime as activity lands). This is a
          perpetual animation mounted in the header on every page, so — like the sidebar logo blink —
          confine its repaints to its own compositing layer. Without it Safari can let the always-running
          animation invalidate the root layer and skip painting unrelated content (e.g. data tables)
          until a hover/scroll forces a repaint. will-change hints the animated properties (opacity +
          the scale transform). motion-safe already disables the blink under prefers-reduced-motion. */}
      <span
        style={{ willChange: "opacity, transform" }}
        className="size-1.5 rounded-full bg-green-500 motion-safe:animate-livePulse"
      />
      <PeriodSelect
        value={period}
        onChange={setPeriod}
        position="left"
        label={activePeriod.collectedLabel}
        buttonClassName="flex cursor-pointer items-center gap-1 text-[11px] font-semibold uppercase tracking-wider text-zinc-400 hover:text-zinc-600"
      />
      {isLoading ? (
        <span className="h-4 w-16 animate-pulse rounded bg-zinc-200" />
      ) : (
        <RollingNumber
          value={data?.collected ?? 0}
          format={formatAmount}
          className="font-semibold text-zinc-800"
          persistKey="metrics.collected.header"
        />
      )}
    </div>
  );
};

export default CollectedToday;
